import { ActionStatus, depascalize } from "sprint-common-web";

import { FileRecordStatus } from "../../../../../common/types/FileRecordStatus";
import { FileRecordListingItem } from "../../types/FileRecordListingItem";

export interface ApproveNotificationsItem {
    id: string;
    deliveryFileName: string;
    content: string;
    status: string;
    filePath?: string;
    isNotificationApproved: boolean;
}

export type ProcessApproveNotificationsItem = ApproveNotificationsItem & {
    processStatus: ActionStatus;
};

export const mapToApproveNotificationsItem = (item: FileRecordListingItem): ApproveNotificationsItem => {
    return {
        id: item.id,
        deliveryFileName: item.deliveryFileName,
        content: item.content ?? "-",
        status: depascalize(FileRecordStatus[item.status]),
        isNotificationApproved: item.isNotificationApproved,
        filePath: item.filePath
    };
};
